<template>
  <div>
    <h1>Teste de Rota</h1>
    <p>Esta é uma página de teste para verificar se o Vue Router está funcionando.</p>
    <p>Serial: {{ $route.query.serial }}</p>
  </div>
</template>

<script>
export default {
  name: 'TestPage'
}
</script>



